import { html, ref, repeat, ViewTemplate, when } from '@microsoft/fast-element';
import type { AutoFillInput } from './auto-fill-input';
import { sync } from '@genesislcap/foundation-utils';

export const AutoFillInputTemplate: ViewTemplate<AutoFillInput> = html`
  <div ${ref('wrapper')}>
    <zero-text-field
      ${ref('autofillElement')}
      class="input-control"
      placeholder="Type and select a suggestion..."
      required=${x => x.required}
      type="text"
      :value=${sync((x) => x.autofillElementValue)}
      ?disabled="${(x) => x.disabled}"
    >
      ${x => x.header}
    </zero-text-field>
    <div style="display: ${(x) => (x.showList ? 'block' : 'none')}">
      <div ${ref('listContainer')} class="list-container">
        ${repeat(x => x.filteredList, html`
          <div class="list-item" @click=${(x, c) => c.parent.selectValue(x)}>${x => x.NAME}</div>
        `)}
        <div style="display: ${(x) => (!x.filteredList.length ? 'block' : 'none')}" class="no-match list-item">No match. Select from available list.</div>
      </div>
    </div>
  </div>
`;
